import { createApp } from 'vue'
import App from '@/page/vue/2024/event/award.vue'
import Antd from 'ant-design-vue'
import Vant from 'vant'

import initShare from '@/utils/wxShare.js'
import tongji from '@/utils/tongji.js'; //引入统计
import 'ant-design-vue/dist/antd.css'

import 'animate.css'
import '@/styles/index.scss'
import 'vant/lib/index.css'

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji(); //统计
initShare({
    title: 'ISC.AI 2024数字安全创新百强评选开启招募',
    desc: '聚焦安全+AI双域，致力挖掘创新标杆力量',
    imgUrl: 'https://p1.ssl.qhimg.com/t01c773b371e5596287.png',
    link: window.location.href
})

const app = createApp(App)
app.use(Vant)
app.use(Antd)

app.mount('#app')
